import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/icons/token.svg'
import _imports_2 from '@/assets/img/icons/plus-yellow.svg'
import _imports_3 from '@/assets/img/icons/ava.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-676d3dd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-6"
}
const _hoisted_2 = {
  key: 1,
  class: "flex"
}
const _hoisted_3 = { class: "sidebar fixed w-1/4 h-screen border-r bg-white" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-3/4 mx-auto my-3"
}, null, -1))
const _hoisted_5 = { class: "border-t pt-2" }
const _hoisted_6 = { class: "text-sm leading-6 text-gray-400" }
const _hoisted_7 = { class: "absolute p-4 bottom-0 w-full" }
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6 text-gray-400" }, "Token anda", -1))
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-6 h-6"
}, null, -1))
const _hoisted_12 = { class: "text-xl leading-7 font-semibold text-gray-900" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "p-1 border-2 border-yellow-400 rounded-md bg-transparent" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1/4" }, null, -1))
const _hoisted_15 = { class: "content w-3/4 bg-white" }
const _hoisted_16 = { class: "flex items-center justify-between py-3 px-6 border-b" }
const _hoisted_17 = { class: "text-base leading-6 text-gray-500 font-semibold tracking-wider" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-5 bg-blue-600 rounded-full px-3 py-1 text-xs leading-5 text-white tracking-wide font-semibold" }, " Admin ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-200 rounded-full mr-3 p-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_21 = { class: "mr-4 text-sm leading-6 font-semibold tracking-wider text-blue-900" }
const _hoisted_22 = { class: "text-xs leading-5 text-gray-500" }
const _hoisted_23 = { class: "p-6" }
const _hoisted_24 = {
  key: 0,
  class: "fixed flex items-center justify-center w-full h-full bg-white opacity-80 z-50 top-0 left-0"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative flex h-8 w-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" }),
  /*#__PURE__*/_createElementVNode("span", { class: "relative inline-flex rounded-full h-8 w-8 bg-blue-500" })
], -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.getIsPlainLayout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, menuIdx) => {
                return (_openBlock(), _createElementBlock("li", { key: menuIdx }, [
                  _createVNode(_component_router_link, {
                    to: menu.path,
                    class: "flex ml-4 items-center py-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle({
                  background: `url(/img/icons/menu/${menu.icon})no-repeat center`,
                }),
                        class: "w-10 h-10 mr-3"
                      }, null, 4),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(menu.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.profileData.token), 1),
                _hoisted_13
              ])
            ])
          ])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.pageTitle), 1),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.profileData.company_name), 1),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.profileData.name), 1)
              ]),
              _createElementVNode("a", {
                class: "cursor-pointer text-blue-800 text-sm ml-2",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, "Logout")
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view)
          ])
        ])
      ]))
}